import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as cookieHelper from '../../sso/helpers/cookie-helper';
import { streamConstants } from '../../../general/js/stream-constants';
import EndeavorCard from '../../endeavor-card/js/endeavor-card';

const LiveCardHighlights = (props) => {
    const { videosData } = props;
    const contentItems = videosData ? videosData.contentItems : [];

    const [displayedGroup, setDisplayedGroup] = useState({ sliceCount: 3, contentItems: [] });

    useEffect(() => {
        const modifiedGroup = getModifiedGroup();
        setDisplayedGroup(modifiedGroup);
    }, []);

    useEffect(() => {
        return () => cookieHelper.removeCookie(streamConstants.videoToBePlayedId);
    }, []);

    const getModifiedGroup = () => {
        const hasMoreLoadedItems = contentItems.length > 3;

        if (!hasMoreLoadedItems) {
            return {
                contentItems,
                sliceCount: 3,
                hasLoadMore: false
            };
        }

        const group = {
            contentItems: contentItems.slice(0, 3),
            sliceCount: 6,
            hasLoadMore: true
        };

        return group;
    };

    const onClickLoadMore = () => {
        const group = { ...displayedGroup };

        group.hasLoadMore = contentItems.length > displayedGroup.sliceCount;
        group.contentItems = contentItems.slice(0, displayedGroup.sliceCount);
        group.sliceCount = displayedGroup.sliceCount + 3;

        setDisplayedGroup(group);
    };

    const getVideos = (group) => {
        if (!group || !Array.isArray(group.contentItems)) return [];

        if (group.hasLoadMore) {
            return group.contentItems.slice(0, group.sliceCount);
        }

        return group.contentItems;
    };


    const videos = getVideos(displayedGroup);
    return (
        <div className="live-card-highlights">
            <div className="live-card-highlights__group">
                {
                    videos.map((video) => (
                        <div key={video.id} className="live-card-highlights__item">
                            <EndeavorCard
                                video={video} />
                        </div>
                    ))
                }
                {
                    displayedGroup.hasLoadMore &&
                                    <div className="live-card-highlights__loadmore">
                                        <button
                                            className="button button--primary"
                                            type="button"
                                            onClick={() => onClickLoadMore()}
                                        >Load more
                                        </button>
                                    </div>
                }
            </div>

        </div>
    );
};

LiveCardHighlights.propTypes = {
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            videos: PropTypes.array,
        })
    )
};

export default LiveCardHighlights;
